// extracted by mini-css-extract-plugin
module.exports = {"H2":"H2_H2__BrL5e"};